export const STEP_ONE = 1;
export const TWO_SMMLV = 2000000;
export const STEP_TWO = 2;
export const STEP_THREE = 3;
export const FIRST_CONTRACT = 0;
export const FIRST_WORK_CENTER = 0;
export const INTEGRAL_SALARY = 'Salario Integral';
export const YES = '1';
export const TERM = 'Término fijo';
export const YES_SPANISH = 'SI';
export const NO = 'NO';
export const STRING = 'string';
export const CONTRACT_TERM_ID = 'contract_term_id';
export const DEPARTMENT_ID = 'department_id';
export const POSITION_ID = 'position_id';
export const COST_CENTER_ID = 'cost_center_id';
export const FINISH_DATE = 'finish_date';
export const ENDOWMENT_VALUE = 'endowment_value';
export const SALARY_TYPE_ID = 'salary_type_id';
export const TRANSPORTATION_ASSISTANCE = 'transportation_assistance';
export const NEW_SALARY_DATE = 'start_date_new_salary';
export const PA = 'PA';
export const CD = 'CD';
export const CONTRACT_TYPE_ID_INDEPENDENT = 'ba3771f3-7847-442a-891d-3e72151496ce';
export const CONTRACT_TERM_ID_UNDEFINED = '0fb938c1-43f8-466b-a0e1-4695f85d7aff';
export const RISK_CLASS_ID_CLASS_FIVE = '428398dd-31a4-426b-84d9-553b7a31bea2';
export const RISK_CLASS_ID_CLASS_FOUR = '7201f62a-5be3-4697-9191-155f7eb91d6b';
export const APPRENTICE_PRODUCTIVE_STAGE = 'd612ca66-2012-444b-9ea2-47d13d0e3a37';
export const APPRENTICE_LECTIVE_STAGE = 'c1983903-268f-486d-8576-0dc2a6392e59';
export const NAME = 'names';
export const SECOND_NAME = 'second_name';
export const LAST_NAME = 'last_names';
export const SECOND_LAST_NAME = 'second_last_name';
export const contractForMoreThanOneMonth = '56d2e75c-ffb1-4be7-ae46-611da00d9548';
export const APPRENTICES_IN_TRAINING_STAGE = 'c1983903-268f-486d-8576-0dc2a6392e59';
export const APPRENTICES_IN_PRODUCTIVE_STAGE = 'd612ca66-2012-444b-9ea2-47d13d0e3a37';
export const DEPENDENT_LINKED_TO_THE_SOCIAL_PROTECTION_FLOOR = '7ce5e2c1-2823-4080-9213-5e833f382ba8';
export const INDEPENDENT_LINKED_TO_THE_SOCIAL_PROTECTION_FLOOR = '3ef867a5-90a0-4ced-aecf-a5ffd13730a4';
export const PART_TIME_WORKER = '4950a347-ab27-46dc-8367-0d5d7ddfd9d3';
export const TAXPAYER_DEPENDENT = 'b7824050-5966-47e8-9e2e-57952c3a6ed3';
export const contractSENA = '4d4d8209-22e4-4614-a563-bb110c42a5e6';
export const contractUniversityPractice = '807223c6-dcfc-4833-906f-823ef133262b';
export const countryColombiaId = '4a0b28a8-4ec7-425b-8e5b-84af3786ee83';
export const supportForSustaining = 'Apoyo de sostenimiento';
export const salary = 'Salario';
export const SUCCESSFULLY_COMPLETED = 'FINALIZADO CON EXITO';
export const dynamicData = [
    'document_type',
    'administrator',
    'country',
    'country_state',
    'county_state_city',
    'compensation_box',
    'type_contributor',
    'type_funder',
    'ciius',
    'risk_class',
    'subtype_contributor',
];
export const contractTerm = [
    'Obra o labor',
    'Término fijo',
    'Contratista',
    'Aprendices de SENA en etapa lectiva',
    'Aprendices de SENA en etapa productiva',
    'Estudiantes (Régimen especial Ley 789 de 2002)',
    'Estudiantes aporte solo riesgos laborales',
];
export const contractType = [
    'Contratista',
    'Aprendices de SENA en etapa lectiva',
    'Aprendices de SENA en etapa productiva',
    'Estudiantes (Régimen especial Ley 789 de 2002)',
    'Estudiantes aporte solo riesgos laborales',
];
export const dynamicEmployee = ['contract_term', 'contract_type', 'salary_type', 'cost_center'];
export const daysOfWeek = [
    {
        value: '1',
        label: 'Lunes',
    },
    {
        value: '2',
        label: 'Martes',
    },
    {
        value: '3',
        label: 'Miércoles',
    },
    {
        value: '4',
        label: 'Jueves',
    },
    {
        value: '5',
        label: 'Viernes',
    },
    {
        value: '6',
        label: 'Sábado',
    },
    {
        value: '7',
        label: 'Domingo',
    },
];
export const dotationOptions = [
    {
        value: 'SI',
        label: 'SI',
    },
    {
        value: 'NO',
        label: 'NO',
    },
];
export const optionsPermanent = [
    {
        value: '1',
        label: 'SI',
    },
    {
        value: '2',
        label: 'NO',
    },
];
export enum TypeData {
    POSITION = 'POSITION',
    DEPARTMENT = 'DEPARTMENT',
    COST_CENTER = 'COST_CENTER',
}
export enum TypeAdministrator {
    EPS = 'EPS',
    ARL = 'ARL',
    PENSIONS = 'AFP',
    LAYOFFS = 'CESANTIA',
}
export enum DayWeek {
    MONDAY = '1',
    TUESDAY = '2',
    WEDNESDAY = '3',
    THURSDAY = '4',
    FRIDAY = '5',
    SATURDAY = '6',
    SUNDAY = '7',
}
export enum CodesDocumentTypes {
    CD = 'CD',
    CE = 'CE',
    PT = 'PT',
    TI = 'TI',
    PA = 'PA',
    SC = 'SC',
    PE = 'PE',
    CC = 'CC',
    RC = 'RC',
    NIT = 'NIT',
}
export enum SalaryTypesId {
    FIXED_SALARY = '6a8e0555-6861-4c5f-9fd0-663887768a58',
    VARIABLE_SALARY = '5d1aae26-89ce-4952-97a5-cc7a5f7412b9',
    FULL_SALARY = '5d1aae26-89ce-4952-97a5-cc7a5f7412b1',
}
export enum SelectTypeSalaryTooltipText {
    FULL_SALARY_TEXT = '',
    VARIABLE_SALARY_TEXT = 'Recuerda que, aunque el valor para el tipo de salario variable inicialmente puede ser cero, debes diligenciar el campo de valor antes de liquidar la nómina de tus empleados en la sección de Liquidación de nómina, en el campo salario básico donde haga falta el valor y solicite Registrar salario, lo que te retornara a este formulario para el respectivo registro',
    FIXED_SALARY_TEXT = 'Recuerda que el salario para los empleados debe tener una asignación como mínimo del  SMMLV del periodo en curso y para Aprendices SENA etapa lectiva debe ser del 50% y en etapa práctica el 100% del SMMLV',
}
export enum StepTwoValues {
    EPS_ID = 'eps_id',
    PENSION_FUND_ID = 'pension_fund_id',
    CESANTIAS_FUND_ID = 'cesantias_fund_id',
    COMPENSATION_BOX_ID = 'compensation_box_id',
    ARL_ID = 'arl_id',
}
export enum TypesDocumentIds {
    CC = '53bedb25-850b-48e7-a7dc-0b0bc5627201',
    CE = '87c68557-fb44-4a6b-965d-7569ac1030e2',
    NIT = '50e64170-7f78-4a9c-80d6-10b0db284228',
    TI = 'e5c162fc-a5b5-4834-9d68-b3f34d79f1f7',
    RC = 'b2af83f0-1258-442f-bbaa-5133f882f1b2',
    PA = '19a9caf2-3ec1-465c-b8f3-90f1a920544b',
    CD = '2dca6dc8-1070-48db-bc3f-ab3846e00feb',
    SC = '539d1bf0-8fd4-49d1-8aa5-7dbaabf2ba99',
    PE = 'db81be81-16cc-4fd9-8da9-e84720af2ba5',
    PT = '4a742ccb-9f64-4f1e-bf9c-eebcac5bafeb',
}
export enum TypesPayMethod {
    TRANSFERABLE_BANK_NOTE = 'f74b5eac-d1e0-479e-85db-41de00cf50b7',
    BANK_CONSIGNMENT = '8e5ef89e-b227-4957-bddc-18894ade9909',
    DEBIT_BANK_TRANSFER = '3f104aaa-5377-46de-8feb-e015a20f0447',
}
export enum TypesPayMethodWithoutData {
    CASH = 'f885a1bb-b026-441b-b41d-ff5bb7b09c74',
    INSTRUMENT_NO_DEFINED = '50cf4f96-dc6d-4468-98d0-1942b3d4cd56',
}
export const localTypesDocument = ['CC', 'NIT', 'TI'];
export const internationalTypeOFDocuments = ['PA', 'CE', 'CD', 'SC', 'PE', 'PT'];
export const foreignerNotRequiredToPayPensionContributions = 'foreigner_not_required_to_pay_pension_contributions';
export const colombianResidentAbroad = 'colombian_resident_abroad';
export const filingDateInExt = 'filing_date_in_ext';
export const stateId = 'state_id';
export const countryId = 'country_id';
export const cityId = 'city_id';
export const address = 'address';
export const messageTooltipButtonValidate =
    'El botón validar te permite consultar y precargar datos previamente registrados en el portal de Seguridad Social PILA o en Bases de referencia, por ello, debes asegurarte en registrar correctamente el tipo y número de documento, si no carga ninguna información deberás diligenciar todos los campos';
export const caseOne = [0, 1, 3, 4, 5, 6, 9, 11, 12];
export const caseTwo = [0, 1, 3, 4, 5];
export const caseThree = [0, 2, 3, 4, 5, 6];
export const caseZero = [0];
export const caseSixteen = [0, 2, 3, 4, 5, 9];
export const caseEighteen = [0, 1, 3, 4, 5, 9];
export const caseTwentyTwo = [0, 1, 3, 4, 5, 6, 9];
export const caseThirty = [0, 1, 3, 4, 5, 6, 9];
export const caseThirtyOne = [0, 1, 3, 4, 5, 9];
export const caseThirtyTwo = [0, 1, 3, 4, 5, 9];
export const caseThirtyFour = [0, 2, 3, 4, 5, 6];
export const caseThirtyFive = [0, 2, 3, 4, 5, 6];
export const caseFortyFour = [0, 1, 3, 4, 5];
export const caseFortySeven = [0, 1, 3, 4, 5, 9];
export const caseFiftyOne = [0, 1, 3, 4, 5];
export const caseFiftyTwo = [0, 3, 4, 5];
export const caseFiftyThree = [0, 2, 3, 4, 5, 6, 9];
export const caseFiftyFive = [0, 1, 3, 4, 5, 9];
export const caseFiftySeven = [0, 2, 3, 4, 5, 6, 11, 12];
export const caseFiftyNine = [0, 2, 3, 4, 5, 6, 9];
export const caseSixtyEight = [0, 1, 3, 4, 5, 6, 9, 11, 12];
